"use strict";
var types_1 = require("../types");
function getNativeEventsHandlers(vidi) {
    // Verifies the vidi instance is still connected to the HTMLVideoElement
    function verifyVideoAndCall(callback) {
        var videoElement = vidi.getVideoElement();
        videoElement && callback(videoElement);
    }
    return {
        loadstart: function () {
            verifyVideoAndCall(function () { return vidi.emit('loadstart', vidi.getPlaybackState()); });
        },
        durationchange: function () {
            verifyVideoAndCall(function (videoElement) { return vidi.emit('durationchange', videoElement.duration); });
        },
        timeupdate: function () {
            verifyVideoAndCall(function (videoElement) { return vidi.emit('timeupdate', videoElement.currentTime); });
        },
        ratechange: function () {
            verifyVideoAndCall(function (videoElement) { return vidi.emit('ratechange', videoElement.playbackRate); });
        },
        volumechange: function () {
            verifyVideoAndCall(function (videoElement) { return vidi.emit('volumechange', { volume: videoElement.volume, muted: videoElement.muted }); });
        },
        play: function () {
            verifyVideoAndCall(function () { return vidi.emit('statuschange', types_1.PlaybackStatus.PLAYING_BUFFERING); });
        },
        playing: function () {
            verifyVideoAndCall(function () { return vidi.emit('statuschange', types_1.PlaybackStatus.PLAYING); });
        },
        pause: function () {
            verifyVideoAndCall(function () { return vidi.emit('statuschange', types_1.PlaybackStatus.PAUSED); });
        },
        seeking: function () {
            verifyVideoAndCall(function (videoElement) {
                if (videoElement.paused) {
                    vidi.emit('statuschange', types_1.PlaybackStatus.PAUSED_BUFFERING);
                }
                else {
                    vidi.emit('statuschange', types_1.PlaybackStatus.PLAYING_BUFFERING);
                }
            });
        },
        seeked: function () {
            verifyVideoAndCall(function (videoElement) {
                if (videoElement.paused) {
                    vidi.emit('statuschange', types_1.PlaybackStatus.PAUSED);
                }
                else {
                    vidi.emit('statuschange', types_1.PlaybackStatus.PLAYING);
                }
            });
        },
        ended: function () {
            verifyVideoAndCall(function () { return vidi.emit('statuschange', types_1.PlaybackStatus.ENDED); });
        },
        error: function (errorEvent) {
            verifyVideoAndCall(function (videoElement) {
                var videoError = videoElement.error;
                var errorType = videoError instanceof MediaError ? types_1.Errors.SRC_LOAD_ERROR : types_1.Errors.UNKNOWN_ERROR;
                vidi.emit('error', errorType, videoElement.src, videoError || errorEvent);
            });
        }
    };
}
exports.getNativeEventsHandlers = getNativeEventsHandlers;
//# sourceMappingURL=native-events-handlers.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/events/native-events-handlers.js
// module id = 1416
// module chunks = 0 1 2 3